<div class="remax-select">
  <label *ngIf="label">{{label}}</label>
  <div class="has-pos-rel select-wrapper" [formGroup]="parentFormGroup">
    <select [formControl]="formControl" (ngModelChange)="modelChange($event)" class="form-control" [required]="isRequired" [compareWith]="compareWith ? compareWith : byValue" [title]="label || placeholder">
      <option value="" disabled selected *ngIf="placeholder">{{placeholder}}</option>
      <option *ngFor="let option of options; let first = first; trackBy: trackBy" [disabled]="option.disabled" [ngValue]="option.value">{{ option.key ? (option.key | translate) : option.text }}</option>
    </select>
    <i class="material-icons dropdown-caret has-pos-abs">keyboard_arrow_down</i>
  </div>
</div>
